import { PREFERRED_CITY_QUESTION_ID } from "../constants/preferences-constants";
import {
    formThreeQuestionsIdMapping,
    questionIDs,
} from "../constants/step-three-constants";
import { CityType } from "../types/step-four-types";
import {
    WorkTypePrefQuestionType,
    PreferencesFormThreeDataType,
} from "../types/step-three-types";
import { getAndroidAppVersion } from "../../../shared/appInterface";

export const getDefaultFormThreeValues: (
    arg0: WorkTypePrefQuestionType[]
) => PreferencesFormThreeDataType = (questions) => {
    const data = {
        employmentType: [""],
        workplace: [""],
        shift: [""],
        salary: [""],
    };

    questions.map((que) => {
        const key = questionIDs.find((id) => id === que.id);

        if (key) {
            const value = formThreeQuestionsIdMapping[key];
            data[value] = [...que.answers];
        }
    });

    return data;
};

export const getCityValueFromPreferenceQuestions: (
    arg0: WorkTypePrefQuestionType[]
) => CityType[] = (questions) => {
    const selectedCity =
        questions
            .find((que) => que.id === PREFERRED_CITY_QUESTION_ID)
            ?.answers?.map((cityId) => ({ id: parseInt(cityId), name: "" })) || [];

    return selectedCity;
};

export const showNewJobTypeScreen = () => {
    /* Android build 850 have profile changes related to new job types screen */
    return getAndroidAppVersion() >= 850;
};

export const showResumeScreen = () => {
    /* Android build 850 have file picker changes*/
    return getAndroidAppVersion() >= 850;
};

export enum JobTypesId {
    DELIVERY_DRIVER_LOGISTICS = "12",
    SECURITY_SERVICE = "36",
    DOMESTIC_WORKER = "13",
    SALES_BD = "35"
}
